import { Injectable } from '@angular/core';
import { LoggedInUser } from '../models/loggedinuser';
import { ConfigurationService } from './configuration.service';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthCodeOptions } from '../models/authCodeOptions';
import { AuthorizationResult } from '../models/authorizationresult';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private configService:ConfigurationService, private http:HttpClient, private cookieService:CookieService) { 
    this.baseUrl = this.configService.getApiEndpoint();
    this.authenticationSubject = new BehaviorSubject<string>('');
    this.authenticationSubscription = this.authenticationSubject.asObservable();
  }

  cookieAuthKey:string = `${this.configService.environment}.strawnypines.loggedinuser`;
  baseUrl:string = '';
  authenticationSubscription:Observable<string>;
  authenticationSubject:BehaviorSubject<string>;
  loginResult:AuthorizationResult|null = null;

  isAuthenticated():boolean {
    if(this.loginResult && this.loginResult.isSuccess)
      return true;
    else {
      let user  = this.getUserFromStorage();
      return user !== null;
    }
  }

  getUserFromStorage() {
    let playerInfo = this.cookieService.get(this.cookieAuthKey);
    if(!playerInfo)
      return null;

    this.loginResult = JSON.parse(playerInfo);
    return this.loginResult;
  }

  async getAuthCodeOptions(email:string):Promise<AuthCodeOptions> {
    let endpoint = `${this.baseUrl}/authcodeoptions`;
    let result = await firstValueFrom(this.http.post<AuthCodeOptions>(endpoint, { email: email }));
    return result;
  }

  async sendAuthCode(authorizationId:number, deliveryMethod:string):Promise<string> {
    let endpoint = `${this.baseUrl}/sendauthcode`;
    let result = await firstValueFrom(this.http.post<string>(endpoint, { authId: authorizationId, deliveryMethod: deliveryMethod }));
    return result;
  }

  async authenticate(code:string, email:string):Promise<AuthorizationResult> {
    let endpoint = `${this.baseUrl}/authenticate`;
    let result = await firstValueFrom(this.http.post<AuthorizationResult>(endpoint, { code: code, email: email }));
    this.loginResult = result;

    this.cookieService.set(this.cookieAuthKey, JSON.stringify(result), this.configService.getAuthCookieExpireDays());
    this.publishLogin();

    return result;
  }

  async logout() {
    this.loginResult ={ isSuccess: false, player: { firstName:'', lastName: '', playerId: -1, email: '', permissions: [] } };
    this.cookieService.delete(this.cookieAuthKey);
    this.publishLogout();
  }

  publishLogin():void {
    this.authenticationSubject.next("LOGIN");
  }

  publishLogout():void {
    this.authenticationSubject.next("LOGOUT");
  }

  async hasPermission(permission:string):Promise<boolean> {
    if(!this.loginResult || !this.loginResult.isSuccess || !this.loginResult.player) return false;
    let user = this.loginResult.player;
    return user.permissions.filter(p => p === permission).length > 0;
  }
}
